<nb-flip-card #flip [showToggleButton]="false">
  <nb-card-front>
    <nb-card accent="primary">
      <nb-card-header>
        <div class="row middle-xs between-xs">
          <div class="col-xs-8 no-padding">
            <strong>{{ record.name }}</strong>
          </div>
          <div class="col-xs-4 no-padding">
            <button
              size="tiny"
              (click)="viewRecord()"
              nbButton
              hero
              [status]="record.hasLineItems ? 'success' : 'info'"
            >
              <ng-container *ngIf="record.hasLineItems && record.activeLineItems.length === 1">
                <nb-icon icon="shopping-cart-outline"></nb-icon>
                Buy
              </ng-container>
              <ng-container *ngIf="!record.hasLineItems">
                <nb-icon icon="info"></nb-icon>
                Info
              </ng-container>
            </button>
          </div>
        </div>
      </nb-card-header>
      <nb-card-body>
        <img
          (click)="viewImages()"
          [src]="record.thumbnails[0]?.downloadURL || 'assets/images/missing_photo.jpg'"
        />
      </nb-card-body>
    </nb-card>
  </nb-card-front>
  <nb-card-back>
    <nb-card>
      <nb-card-body>
        <app-gallery-record-detail [record]="record"></app-gallery-record-detail>
        <app-add-to-cart
          *ngIf="record.activeLineItems && record.activeLineItems.length === 1"
          [galleryRecord]="record"
          [lineItem]="record.activeLineItems[0]"
        ></app-add-to-cart>
      </nb-card-body>
      <nb-card-footer>
        <button (click)="flip.flipped = !flip.flipped" size="tiny" nbButton ghost status="primary">
          <nb-icon icon="arrow-back-outline"></nb-icon>
          Back
        </button>
      </nb-card-footer>
    </nb-card>
  </nb-card-back>
</nb-flip-card>
